import type { ContactRow } from "../../lib/db";
import type { PresenceStatus } from "../../styles/theme";
import type { IncomingReq } from "./domainTypes";

export type ContactsState = {
  contacts: ContactRow[];
  incoming: IncomingReq[];
  addUser: string;
  unreadCounts: Record<string, number>;
  presenceByUserId: Record<string, PresenceStatus>;
};

export type ContactsAction =
  | { type: "set-contacts"; contacts: ContactRow[] }
  | { type: "set-incoming"; incoming: IncomingReq[] }
  | { type: "remove-incoming"; userId: string }
  | { type: "set-add-user"; value: string }
  | { type: "set-unread-counts"; counts: Record<string, number> }
  | { type: "set-presence"; userId: string; status: PresenceStatus }
  | { type: "reset-presence" }
  | { type: "reset" };

export function initialContactsState(): ContactsState {
  return {
    contacts: [],
    incoming: [],
    addUser: "",
    unreadCounts: {},
    presenceByUserId: {},
  };
}

export function contactsReducer(state: ContactsState, action: ContactsAction): ContactsState {
  switch (action.type) {
    case "set-contacts":
      return { ...state, contacts: action.contacts };
    case "set-incoming":
      return { ...state, incoming: action.incoming };
    case "remove-incoming":
      return { ...state, incoming: state.incoming.filter((item) => item.from_id !== action.userId) };
    case "set-add-user":
      return { ...state, addUser: action.value };
    case "set-unread-counts":
      return { ...state, unreadCounts: action.counts };
    case "set-presence":
      return {
        ...state,
        presenceByUserId: {
          ...state.presenceByUserId,
          [action.userId]: action.status,
        },
      };
    case "reset-presence":
      return { ...state, presenceByUserId: {} };
    case "reset":
      return initialContactsState();
    default:
      return state;
  }
}
